export const ANALYTIC_TABLE_TITLE = "Tabla analítica";
